<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $t('messages.school_year'),
                        href: meta.links.index,
                    },
                    {
                        name: schoolYear.year_range,
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 1,
                                    })
                                "
                                for="first_trimester_start_date"
                            />
                            {{ form.first_trimester_start_date }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 1,
                                    })
                                "
                                for="first_trimester_end_date"
                            />
                            {{ form.first_trimester_end_date }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 2,
                                    })
                                "
                                for="second_trimester_start_date"
                            />
                            {{ form.second_trimester_start_date }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 2,
                                    })
                                "
                                for="second_trimester_end_date"
                            />
                            {{ form.second_trimester_end_date }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.start_of_X_trimester', {
                                        number: 3,
                                    })
                                "
                                for="third_trimester_start_date"
                            />
                            {{ form.third_trimester_start_date }}
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel
                                :value="
                                    $t('messages.end_of_X_trimester', {
                                        number: 3,
                                    })
                                "
                                for="third_trimester_end_date"
                            />
                            {{ form.third_trimester_end_date }}
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
    },
    layout: AdminLayout,
    name: 'Show',
    props: ['schoolYear', 'meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                first_trimester_start_date: this.schoolYear.first_trimester_start_date,
                first_trimester_end_date: this.schoolYear.first_trimester_end_date,
                second_trimester_start_date: this.schoolYear.second_trimester_start_date,
                second_trimester_end_date: this.schoolYear.second_trimester_end_date,
                third_trimester_start_date: this.schoolYear.third_trimester_start_date,
                third_trimester_end_date: this.schoolYear.third_trimester_end_date,
            }),
        };
    },
    methods: {},
};
</script>
